import { reactive, ref } from "vue";
import { ws_instance } from "../websocket/ws-instance";
import { roomState } from "./room";
import { addNotification } from "./notifications";
import { locale } from "../locale";
import { fetcher } from "../api/fetcher";
import { isSelfAdmin } from "./adminsState";

export const recordState = reactive({
  recording: false,
});

export const loadingRecordState = ref(false);

export const ChangeRecord = () => {
  if (loadingRecordState.value) return;
  if (!recordState.recording) {
    loadingRecordState.value = true;
    startRecord().catch((err) => {
      if (err?.status !== 401) {
        showWaitRecordNotification();
      }
    });
  } else {
    stopRecord();
  }
};

export function subscribeRecordEvents() {
  ws_instance.addEventListener("start-record", () => {
    recordState.recording = true;
    loadingRecordState.value = false;
    showStartRecordNotification();
  });

  ws_instance.addEventListener("start-record-error", () => {
    if (isSelfAdmin.value) {
      loadingRecordState.value = false;
      showErrorRecordNotification();
    }
  });

  ws_instance.addEventListener("end-record", () => {
    recordState.recording = false;
    loadingRecordState.value = false;
    showEndRecordNotification();
  });

  ws_instance.addEventListener("loading-record", () => {
    recordState.recording = false;
    loadingRecordState.value = true;
  });
}

function showStartRecordNotification() {
  addNotification(4, locale.ustartrecord, "RecordIconN");
}

export function showRoomRecordNotification() {
  addNotification(4, locale.roomrecords, "RecordIconN");
}

function showWaitRecordNotification() {
  addNotification(4, locale.uwaitrecord, "RecordIconN");
}

function showErrorRecordNotification() {
  addNotification(4, locale.uerrorrecord, "RecordIconN");
}

function showEndRecordNotification() {
  addNotification(4, locale.uendrecord, "RecordIconN");
}

async function startRecord() {
  return fetcher.post({
    path: "/active-room/start-record",
    payload: {
      roomId: roomState.id,
    },
  });
}

async function stopRecord() {
  fetcher.post({
    path: "/active-room/stop-record",
    payload: {
      roomId: roomState.id,
    },
  });
}
